import React,{useState,useEffect,useRef} from "react";
import axios from "../../plugins/axios";
import { useTranslation } from "react-i18next";

import { ReactComponent as IconCloseBlack } from '../../assets/icons/ic-close-black.svg';
import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up-gray.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down-gray.svg'
import {ReactComponent as IconCheck} from '../../assets/icons/ic-check-blue.svg'

const PrintModal = ({handleClose,handleAlarmPrint}) => {
    const { t } = useTranslation()
    const dropdownRefs = useRef([]);
    const [waveCodeList, setWaveCodeList] = useState([])
    const [waveParameters, setWaveParameters] = useState([])

    const [dropdownStates, setDropdownStates] = useState({
        wave1: false,
        wave2: false,
        wave3: false,
        wave4: false,
    });

    const [waveDatas, setWaveDatas] = useState({
        wave1: [],
        wave2: [],
        wave3: [],
        wave4: [],  
    })

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    // Wave Code List 가져오기
    const getWaveCodeList = async () => {
        try {
            const waveCodeRes = await axios.get(`/measure/parameters/wave`);
            if (waveCodeRes.code != '200') throw waveCodeRes;            
            setWaveCodeList(waveCodeRes.data.parameters);
            const lead2 = waveCodeRes.data.parameters.find(item => item.parameter === 'LEADⅡ');
            const pleth = waveCodeRes.data.parameters.find(item => item.parameter === 'PLETH');
            const resp = waveCodeRes.data.parameters.find(item => item.parameter === 'RESP');
            const ibp1 = waveCodeRes.data.parameters.find(item => item.parameter === 'IBP1');
            setWaveParameters([
                { measureParameterId: lead2.id, measureParameter: lead2.parameter, measureParameterName: lead2.name },
                { measureParameterId: pleth.id, measureParameter: pleth.parameter, measureParameterName: pleth.name },
                { measureParameterId: resp.id, measureParameter: resp.parameter, measureParameterName: resp.name },
                { measureParameterId: ibp1.id, measureParameter: ibp1.parameter, measureParameterName: ibp1.name }
            ])
        } catch (err) { console.warn(err) }
    }

    const handleChangeSelect = (val, index) => {
        const updatedWaveParameters = [...waveParameters];
        updatedWaveParameters[index] = {
            ...updatedWaveParameters[index],
            measureParameterId: val.id,
            measureParameter: val.parameter,
            measureParameterName: val.name
        };
        setWaveParameters(updatedWaveParameters);
    }

    // ✅ Numeric DropDown 상태 변경
    const handleClickOutside = (event) => {
        // 모든 드롭다운 ref를 확인
        let isClickedInside = false;
        dropdownRefs.current.forEach(ref => {
            if (ref && ref.contains(event.target)) {
                isClickedInside = true;
            }
        });
        
        if (!isClickedInside) {
            setDropdownStates({
                wave1: false,
                wave2: false,
            });
        }
    };

    useEffect(() => {
        getWaveCodeList()

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])

    return (
        <div className="absolute w-[328px] h-[180px] top-1/3 content-center whitespace-pre-line" style={{ background: 'rgba(0,0,0,0.3)' }}>
            <div className="mx-auto bg-[#DEDEDE] text-center flex flex-col rounded-[8px]">
                <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="text-[#000]">{t('alarmReview.print')}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={handleClose} />
                </div>

                <div className="w-full flex-1 flex items-start flex-col bg-[#DEDEDE] px-[20px] mb-[8px]">
                    {
                        waveParameters.map((parameter, idx) => (
                            <div key={idx} className="relative w-full">
                                <p className='w-full text-left text-[#000] pt-[20px]'>{t('alarmReview.wave')} {idx + 1}</p>                    
                                <div className="relative my-[5px]" ref={el => dropdownRefs.current[idx] = el}>
                                    <div className="bg-[#fff] text-[#000] w-full h-[26px] py-[5px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between" 
                                        onClick={
                                            (e) => {
                                                e.stopPropagation();
                                                setDropdownStates((prev) => {
                                                    const isAlreadyOpen = prev[`wave${idx + 1}`];
                                                    const newStates = {};
                                                    waveParameters.forEach((_, i) => {
                                                        // 본인만 토글, 나머지는 false
                                                        newStates[`wave${i + 1}`] = i === idx ? !isAlreadyOpen : false;
                                                    });
                                                    return newStates;
                                                });
                                            }
                                        }>
                                        <div className="w-full text-left">{parameter.measureParameter}</div>
                                    </div>
                                    {
                                        dropdownStates[`wave${idx + 1}`] && (
                                            <div className="absolute top-[30px] bg-[#fff] w-full py-[8px] rounded-[6px] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] scrollbar scrollbar--gray scrollbar-h-small max-h-[200px]" style={{zIndex:9999}}>
                                                {
                                                // ✅ 다른 곳에서 사용 중인 code 필터링 (현재 선택된 것은 예외)
                                                waveCodeList
                                                    .filter(code => {
                                                        // 현재 파라미터와 같으면 항상 표시
                                                        if (code.id === parameter.measureParameterId) {
                                                            return true;
                                                        }
                                                        
                                                        // 다른 드롭다운에서 사용 중인지 확인
                                                        const isUsedInOtherDropdown = waveParameters.some((param, paramIdx) =>
                                                            paramIdx !== idx && param.measureParameterId === code.id
                                                        );
                                                        
                                                        // 다른 곳에서 사용하지 않는 것만 표시
                                                        return !isUsedInOtherDropdown;
                                                    })
                                                    .map((code, codeIdx) => (
                                                        <div 
                                                            className={`bg-[#fff] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#F4F4F4] ${parameter.measureParameterId === code.id ? "text-[#3182F7]" : "text-[#000]"}`} 
                                                            onClick={(e) => { 
                                                                e.stopPropagation();                                                                         
                                                                handleChangeSelect(code, idx); 
                                                                
                                                                // 드롭다운 닫기 (값이 다를 때만)
                                                                if (parameter.measureParameterId !== code.parameter) {
                                                                    setDropdownStates((prev) => ({ 
                                                                        ...prev, 
                                                                        [`wave${idx + 1}`]: false 
                                                                    }));
                                                                }
                                                            }}
                                                            key={`wave-${idx + 1}-code-${codeIdx}`}
                                                        >
                                                            {code.parameter}
                                                            {parameter.measureParameterId === code.id && (
                                                                <IconCheck className="w-4 h-4 ml-2" />
                                                            )}
                                                        </div>
                                                    ))
                                            }
                                            </div>
                                        )
                                    }
                                    <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                                        {dropdownStates[`wave${idx + 1}`] ?  <IconArrowUp/> : <IconArrowDown/>}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    
                </div>

                <div className="flex items-center justify-end bg-[#DEDEDE] px-[20px] py-[12px] rounded-bl-[8px] rounded-br-[8px]">
                    <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] mr-[8px]  gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] cursor-pointer text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={handleClose}>{t('alarmReview.cancel')}</div>
                    <div className={`cursor-pointer flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]`} onClick={() => handleAlarmPrint(waveParameters)}>{t('alarmReview.print')}</div>
                </div>
            </div>
        </div>
    )
}

export default PrintModal